import React from "react";
import i18n from "i18next";

class SuggestList extends React.Component {
  render() {
    const itemList = this.props.itemList || [];
    return (
      <div className="search-research-history flex-column">
        <h5>{i18n.t("TCMS01012_searchHistory")}</h5>
        {itemList.map((item, index) => (
          <span key={index}>
            <div onClick={() => this.props.onClick && this.props.onClick(item)} tabIndex="0">
              {item.content}
            </div>
          </span>
        ))}
      </div>
    );
  }
}

export default SuggestList;
